// src/i18n.js
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import {config} from './libs/utils';
// import en from '@/assets/i18n/en.json'

// Get language from query route if present
function getLanguageFromQuery() {
  const params = new URLSearchParams(window.location.search);
  return params.get('lang');
}

const defaultLocale = config.VUE_APP_LANGUAGES.find(lang => lang.default)?.value || 'en';

Vue.use(VueI18n);

const savedLanguage = localStorage.getItem("user-language")

const i18n = new VueI18n({
  locale: savedLanguage|| defaultLocale, // Set the initial locale
  fallbackLocale:defaultLocale,
  silentTranslationWarn: true, // Suppress warnings for missing translations
  messages: {}
});


export async function loadLocaleMessages(locale) {
  try {
    let forcedLocale = getLanguageFromQuery()
    if(forcedLocale) {
      locale = forcedLocale;
    }
    // Dynamic import based on locale
    const messages = await import(`@/assets/i18n/${locale}.json`);
    i18n.setLocaleMessage(locale, messages.default);

    // Set the loaded locale as active
    i18n.locale = locale;
    localStorage.setItem("user-language", locale);

    return Promise.resolve();
  } catch (error) {
    console.error(`Failed to load ${locale} translations`, error);
    return Promise.reject(error);
  }
}

// Load the initial language
loadLocaleMessages(savedLanguage).catch(() => {
  // Fallback to default if saved language fails to load
  loadLocaleMessages(defaultLocale);
});

export default i18n